'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SDMX_3_0_JSON_DATA_FORMAT = exports.SDMX_3_0_JSON_DATA_FORMAT = 'application/vnd.sdmx.data+json;version=2.0';
var SDMX_3_0_CSV_DATA_FORMAT = exports.SDMX_3_0_CSV_DATA_FORMAT = 'application/vnd.sdmx.data+csv;version=2.0';
var EMPTY_ATTACHMENT_LEVEL_CHAR = exports.EMPTY_ATTACHMENT_LEVEL_CHAR = '~';
var REPORTING_YEAR_START_DAY = exports.REPORTING_YEAR_START_DAY = 'REPORTING_YEAR_START_DAY';
var REPYEARSTART = exports.REPYEARSTART = 'REPYEARSTART';
var REJECTED_VALUE_IDS = exports.REJECTED_VALUE_IDS = ['_L', '_T', '_Z'];